/* 
 * Shows info on input about edit mode turn off
 */

app.service("_$editmode",function(_$toast){
    
    
    this.turnOff=function(){
        
        this.turnOn(); //unbind
    
        $("body").on("click.editmode","form md-input-container:not([data-exception])",function(){
           
            // _$snackbar.show("Jesteś w trybie tylko do odczytu");
             _$toast.message("Jesteś w trybie tylko do odczytu");
             
        });
        
        
    };
    
    this.turnOn=function(){
        
        $("body").unbind("click.editmode");
        
        
    };
    
});




